import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  textColor?: string;
}

export const Root = styled.div`
  position: relative;
`

export const InputContainer = styled.input`
  height: 48px;
  width: calc(100% - 32px);
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.LIGHT_GRAY};
  padding: 0px 16px;
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
    outline: none;
  }
`

export const TipLabel = styled.div`
  position: absolute;
  height: 14px;
  margin: 4px 0px 0px 0px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props:IRootProps) => props.textColor ? props.textColor : '#8891a0'};
`
